import React from 'react';
import { FaLinkedin, FaEnvelope, FaPhone, FaGlobe, FaHeart, FaArrowUp, FaBullseye } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'Website',
      url: 'https://portfolioweb.fliphatmedia.com',
      icon: <FaGlobe />
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/harish-kumar-10a0192b9/',
      icon: <FaLinkedin />
    },
    {
      name: 'Email',
      url: 'mailto:imdigitalharish@gmail.com',
      icon: <FaEnvelope />
    }
  ];

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Portfolio', href: '#portfolio' },
    { name: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId.substring(1));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <h3 className="footer-logo"><FaBullseye className="logo-icon" /> Harish Kumar</h3>
            <p className="footer-tagline">
              Architecting Brands that Convert
            </p>
            <p className="footer-description">
              I blend marketing psychology with technical execution to build digital experiences that deliver measurable results.
            </p>
            
            <div className="footer-contact">
              <div className="contact-item">
                <FaEnvelope />
                <a href="mailto:imdigitalharish@gmail.com">imdigitalharish@gmail.com</a>
              </div>
              <div className="contact-item">
                <FaPhone />
                <a href="tel:+919602003790">+91 96020 03790</a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button 
                    onClick={() => scrollToSection(link.href)}
                    className="footer-link"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="footer-services">
            <h4>Services</h4>
            <ul>
              <li>Brand Building & Strategy</li>
              <li>Social Media Marketing</li>
              <li>Marketing Automation</li>
              <li>SEO & Content Strategy</li>
              <li>Website Development</li>
            </ul>
          </div>

          {/* Connect */}
          <div className="footer-social">
            <h4>Let's Connect</h4>
            <p>Ready to build your growth machine?</p>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
            
            <div className="footer-cta">
              <a href="mailto:imdigitalharish@gmail.com" className="btn btn-primary">
                Discuss Your Project
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>
                © {currentYear} Harish Kumar. Made with <FaHeart className="heart-icon" /> in Ahmedabad, India
              </p>
            </div>
            
            <div className="footer-credits">
              <p>Built by Harish • Designed for Results</p>
            </div>


          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
